<template>
	<div class="page-loader">
		<loading-bar
		id="loading-bar-id"
		custom-class="innerloader"
		:on-error-done="errorDone"
		:on-progress-done="progressDone"
		:progress="progress"
		:direction="direction"
		:error="error" >
	</loading-bar>
</div>
</template>
<script>
import LoadingBar from 'vue2-loading-bar/build/vue2-loading-bar.js'
import 'vue2-loading-bar/src/css/loading-bar.css'
export default {
	name: "Loader",
	components: {
		LoadingBar,
	},
	prop:{
		rtl:{
			type:Boolean,
			default:true,
			required: true
		}
	},
	data() {
		return {
			progress: 0,
			error: false,
			direction: this.rtl == true ? "right" : "left"
		}
	},
	methods:{
		errorDone(){
			this.error = false
		},
		progressDone() {
			this.progress = 0
		},
	},
	mounted: function () {
		var me = this;
		me.progress = 10;
		for (var i = 0; i < 30; i++) {
			if(i > 20 && i < 29){
				setTimeout(function () {
					me.progress += 5;
				},50*i);
			}else{
				setTimeout(function () {
					me.progress ++;
				},10*i);
			}
		}
		setTimeout(function () {
			me.progress = 100;
		},1500);
	}
};

</script>
<style>
.page-loader{
	position: absolute;
	width: 100%;
	height: 5px;
	left: 0;
	right: 0;
	z-index: 9999999;
}
.page-loader .innerloader{
	background: #fff;
}
.page-loader .innerloader .LoadingBar-glow{
	box-shadow: -3px 0 15px 1px #fff;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/front/components/LoadingBar.vue